import { createContext, useContext } from 'react';
export var CepContext = createContext(undefined);
export function useTableCep() {
  return useContext(CepContext);
}
var DIV = 'div';
var SPAN = 'span';
export var IMPLEMENT_DIV = {
  isTable: false,
  Table: DIV,
  TBody: DIV,
  THead: DIV,
  TFoot: DIV,
  TR: DIV,
  TH: SPAN,
  TD: SPAN,
  Col: DIV,
  ColGroup: DIV,
  Caption: DIV
};
export var IMPLEMENT_TABLE = {
  isTable: true,
  Table: 'table',
  TBody: 'tbody',
  THead: 'thead',
  TFoot: 'tfoot',
  TR: 'tr',
  TH: 'th',
  TD: 'td',
  Col: 'col',
  ColGroup: 'colgroup',
  Caption: 'caption'
};
export var ImplementContext = createContext(IMPLEMENT_TABLE);
export var useTableImplement = function useTableImplement() {
  return useContext(ImplementContext);
};